'use client'

import * as React from 'react'
import { Toast as ToastPrimitive } from '@base-ui/react/toast'

import { toastManager } from '@/hooks/use-toast'
import { cn } from '@/lib/utils'
import {
  ToastClose,
  ToastContent,
  ToastDescription,
  ToastPortal,
  ToastProvider,
  ToastRoot,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast'

function ToastList() {
  const { toasts } = ToastPrimitive.useToastManager<{
    className?: string
    style?: React.CSSProperties
  }>()

  return (
    <>
      {toasts.map((toast) => (
        <ToastRoot
          key={toast.id}
          toast={toast}
          className={toast.data?.className}
          style={toast.data?.style}
        >
          <ToastContent>
            <div className="grid gap-1">
              <ToastTitle />
              <ToastDescription />
            </div>
            {toast.actionProps ? (
              <button
                type="button"
                className={cn(
                  'hover:bg-secondary focus:ring-ring group-data-[type=destructive]:border-muted/40 group-data-[type=destructive]:hover:border-destructive/30 group-data-[type=destructive]:hover:bg-destructive group-data-[type=destructive]:hover:text-destructive-foreground group-data-[type=destructive]:focus:ring-destructive inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors focus:ring-1 focus:outline-none disabled:pointer-events-none disabled:opacity-50',
                )}
                {...toast.actionProps}
              />
            ) : null}
            <ToastClose />
          </ToastContent>
        </ToastRoot>
      ))}
    </>
  )
}

export function Toaster() {
  return (
    <ToastProvider toastManager={toastManager} limit={1}>
      <ToastPortal>
        <ToastViewport>
          <ToastList />
        </ToastViewport>
      </ToastPortal>
    </ToastProvider>
  )
}
